<!-- src/components/SidebarNavigation.vue -->
<template>
  <div class="sidebar-nav">
    <div class="nav-icons">
      <!-- 品牌Logo图标 -->
      <div class="logo-container">
        <svg width="40" height="40" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="title desc">
          <title id="title">印记云 | 云端速记好帮手</title>
          <desc id="desc">一个浅紫与白色的云形图标，中间有笔记卡片与书签，居中放置在正方形画布中，极简设计，用于社交头像或应用图标。</desc>

          <defs>
            <!-- 纯紫色填充 -->
            <linearGradient id="gPrimary" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stop-color="#7C3AED"/>
              <stop offset="100%" stop-color="#7C3AED"/>
            </linearGradient>
            <linearGradient id="gSheen" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0.9"/>
              <stop offset="100%" stop-color="#FFFFFF" stop-opacity="0"/>
            </linearGradient>
            <filter id="softShadow" x="-20%" y="-20%" width="140%" height="160%" color-interpolation-filters="sRGB">
              <feDropShadow dx="0" dy="8" stdDeviation="16" flood-color="#6D28D9" flood-opacity="0.2"/>
            </filter>

            <!-- 图标符号 -->
            <symbol id="logoIcon" viewBox="0 0 256 256">
              <g filter="url(#softShadow)">
                <path d="M174 108c-3.8-24.6-25.4-44-51.6-44-22.3 0-41.4 13.8-48.8 33.1-22.3 1.7-39.6 20.3-39.6 42.9 0 23.8 19.3 43.1 43.1 43.1h111.2c22.2 0 40.3-18 40.3-40.3 0-21.2-16.3-38.6-36.9-40.8z"
                      fill="url(#gPrimary)"/>
                <path d="M66 136c0-22 18-40 40-40 10 0 19 3 26.5 8.5 7.5 5.5 17 8.5 26.5 8.5 19 0 35-12 40-28 9 6 15 16 15 28 0 20-17 36-38 36H90c-13.3 0-24-10.7-24-24z"
                      fill="url(#gSheen)" opacity="0.4"/>
              </g>
              <g transform="translate(76,86)">
                <path d="M0 18c0-9.94 8.06-18 18-18h60c4.24 0 8.31 1.68 11.31 4.69L110 21.38V96c0 9.94-8.06 18-18 18H18c-9.94 0-18-8.06-18-18V18z"
                      fill="#FFFFFF"/>
                <path d="M89 0l21 21h-13c-4.42 0-8-3.58-8-8V0z" fill="#EDE9FE" />
                <path d="M24 18h20c2.21 0 4 1.79 4 4v54l-14-8-14 8V22c0-2.21 1.79-4 4-4z"
                      fill="#7C3AED"/>
                <rect x="52" y="32" width="44" height="6" rx="3" fill="#A78BFA"/>
                <rect x="52" y="52" width="44" height="6" rx="3" fill="#C4B5FD"/>
                <rect x="52" y="72" width="34" height="6" rx="3" fill="#DDD6FE"/>
                <circle cx="100" cy="16" r="6" fill="#FFFFFF" opacity="0.9"/>
              </g>
              <path d="M174 108c-3.8-24.6-25.4-44-51.6-44-22.3 0-41.4 13.8-48.8 33.1-22.3 1.7-39.6 20.3-39.6 42.9 0 23.8 19.3 43.1 43.1 43.1h111.2c22.2 0 40.3-18 40.3-40.3 0-21.2-16.3-38.6-36.9-40.8z"
                    fill="none" stroke="#A78BFA" stroke-opacity="0.7" stroke-width="2"/>
            </symbol>
          </defs>
          
          <!-- 图标居中 - 调整偏移量以适应新尺寸 -->
          <g transform="translate(12,12)">
            <use href="#logoIcon" width="376" height="376"/>
          </g>
        </svg>
      </div>

      <!-- 文件管理图标 -->
      <button 
        class="nav-icon-btn" 
        :class="{ active: activeView === 'files' }"
        @click="setActiveView('files')"
        title="文件管理"
      >
        <i class="el-icon-folder-opened"></i>
        <!-- <i class="icon-file-text"></i> -->
      </button>
      
      <div class="avatar-container"
        @click="setActiveView('user')"
      >
        <AvatarComponent 
          :username="username" 
        />
        <div style="font-size: 14px; color: rgb(255, 255, 255);">{{username}}</div>
      </div>
    </div>

    <div class="nav-content">
      <!-- 使用动态组件根据 activeView 切换显示 -->
      <component 
        :is="currentComponent" 
        @file-selected="onFileSelected"
        @file-added="onFileAdded"
        @file-deleted="onFileDeleted"
        @file-renamed="onFileRenamed"
      />
    </div>
  </div>
</template>

<script>
import FileTree from './FileTree.vue'; // 引入文件树组件
import UserInfo from './UserInfo.vue';
import AvatarComponent from './AvatarComponent.vue';

export default {
  name: 'SidebarNavigation',
  components: {
    FileTree,
    UserInfo,
    AvatarComponent
  },
  props: {
  },
  data() {
    return {
      activeView: 'files' // 默认显示文件管理
    };
  },
  computed: {
    username() {
      const originalUsername = this.$store.state.username;
      if (originalUsername && originalUsername.length > 6) {
        return originalUsername.substring(0, 6) + '..';
      }
      return originalUsername;
    },
    email(){
      return this.$store.state.email;
    },

    currentComponent() {
      // 根据 activeView 返回对应的组件名称
      switch (this.activeView) {
        case 'files':
          return 'FileTree';
        case 'ai':
          return 'AiChatPlaceholder'; // 返回AI聊天组件
          // return 'div'; // 临时返回一个空div作为占位符，直到AiChatPlaceholder.vue创建
        case 'user':
          return 'UserInfo';
        default:
          return 'FileTree';
      }
    }
  },
  methods: {
    setActiveView(viewName) {
      this.activeView = viewName;
    },
    onFileSelected(fileId) {
      // 将文件选择事件传递给父组件 App.vue
      this.$emit('file-selected', fileId);
    },
    onFileAdded(newFile) {
      // 将文件添加事件传递给父组件 App.vue
      this.$emit('file-added', newFile);
    },
    onFileDeleted(fileId) {
      // 将文件删除事件传递给父组件 App.vue
      this.$emit('file-deleted', fileId);
    },
    onFileRenamed(fileId, newName) {
       // 将文件重命名事件传递给父组件 App.vue
      this.$emit('file-renamed', fileId, newName);
    }
  }
}
</script>

<style scoped>
.sidebar-nav {
  display: flex;
  height: 100%;
  background: rgba(255, 255, 255, 0.95);
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  flex-direction: row; /* 水平排列图标和内容 */
}

.nav-icons {
  border-radius: 12px 12px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 10px;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
  background: var(--header-bg-purple-blue-alpha, rgba(237, 233, 254, 0.95)); /* 使用与页头一致的背景色 */
}

/* Logo容器样式 */
.logo-container {
  margin-bottom: 20px;
  padding: 5px;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.nav-icon-btn {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #000000;
  cursor: pointer;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: all 0.2s ease;
}

.nav-icon-btn:hover {
  background: rgba(100, 116, 139, 0.1);
  color: #475569;
  transform: translateY(-2px);
}

.nav-icon-btn.active {
  background: linear-gradient(135deg, var(--primary-gradient-start, #667eea) 0%, var(--primary-gradient-end, #764ba2) 100%);
  color: white;
  box-shadow: 0 4px 10px rgba(102, 126, 234, 0.3);
}

.nav-content {
  flex: 1;
  overflow: hidden; /* 防止内容溢出 */
  display: flex;
  flex-direction: column;
}

.avatar-container{
  margin-top:65vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s ease;
  width: 100%;
}

.avatar-container:active {
  transform: scale(0.9);
  opacity: 0.8;
}

.avatar-container:hover {
  transform: scale(1.05);
}

/* 图标字体定义 */
.icon-file-text::before { content: "📂"; } /* 或使用您原来的 📖 */
.icon-ai-chat::before { content: "💬"; } /* AI聊天图标 */

/* 响应式 - 在小屏幕上可能需要调整 */
@media (max-width: 768px) {
  .sidebar-nav {
    flex-direction: column; /* 在小屏幕上变为上下排列 */
    height: auto;
  }
  .nav-icons {
    flex-direction: row;
    border-right: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    padding: 10px 20px;
  }
  .nav-icon-btn {
    margin-bottom: 0;
    margin-right: 15px;
  }
  .logo-container {
    margin-bottom: 0;
    margin-right: 15px;
  }
}
</style>